export default __webpack_public_path__ + "static/media/Montserrat-Black.1b9fba4a.ttf";